export const hoverSelector = 'html:not(.touch) &:hover';
